import { DefinedError } from 'genesys/error/error-state';
import { ChatbotError } from 'state/chatbot-error';
import messages from './messages';

/**
 * error scenario's
 */
const chatBotErrorMessages = {
  [ChatbotError.WelcomeError]: [
    messages.chatBotError,
    { errorCode: 'GBB-CBT-0002' },
  ],
  [ChatbotError.FirstInteractionError]: [
    messages.chatBotError,
    { errorCode: 'GBB-CBT-0003' },
  ],
  [ChatbotError.NextInteractionError]: [
    messages.chatBotError,
    { errorCode: 'GBB-CBT-0004' },
  ],
  [ChatbotError.InChatInteractionError]: [
    messages.chatBotInChatError,
    { errorCode: 'GBB-CBT-0004' },
  ],
};

/**
 * getMessageForError
 */
export const getErrorMessage = (chatbotError, genesysError) => {
  if (!chatbotError && !genesysError) {
    return undefined;
  }

  if (chatbotError) {
    return chatBotErrorMessages[chatbotError];
  }

  if (genesysError === DefinedError.AuthConversationRestoreError) {
    return [messages.genesysRetrieveError, { errorCode: genesysError }];
  } else {
    return [messages.genesysError, { errorCode: genesysError }];
  }
};
